<template>
  <material-card
    :title="$t('views.guides.search_per_benefit')"
    icon="description"
    style="margin-top:20px"
  >
    <v-card-text>
      <v-form>
        <v-container fluid>
          <v-row>
            <v-col xs="12" sm="6" md="4" lg="3">
              <trans-select
                :clearable="true"
                :item="selected"
                propertyName="province"
                :items="options.Models.Province"
                :label="$t('globals.province')"
              ></trans-select>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <trans-select2
                :clearable="true"
                v-model="selected"
                propertyName="benefit"
                :items="benefits"
                :label="$t('globals.benefit')"
                field="Name"
                itemValue="Id"
              ></trans-select2>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <no-autocomplete-textfield
                :clearable="true"
                :label="$t('globals.category')"
                v-model="selected.category"
                clear-icon="clear"
              ></no-autocomplete-textfield>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <!-- <v-menu
                v-model="dateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    clearable
                    v-model="dateRangeText"
                    :label="
                      $t('components.guides.search_per_benefit.date_range')
                    "
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                  ></v-text-field>
                </template>
                <v-date-picker range v-model="selected.dates"></v-date-picker>
              </v-menu> -->
              <v-autocomplete
                :clearable="true"
                :label="$t('components.guides.search_per_benefit.year_from')"
                v-model="selected.yearFrom"
                clear-icon="clear"
                :items="years()"
              ></v-autocomplete>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-autocomplete
                :clearable="true"
                :label="$t('components.guides.search_per_benefit.year_to')"
                v-model="selected.yearTo"
                clear-icon="clear"
                :items="years()"
              ></v-autocomplete>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <trans-enum
                :clearable="true"
                :value.sync="selected.coverage"
                :items="options.Enums.Coverage"
                :label="
                  $t('globals.coverage')
                "
              ></trans-enum>
            </v-col>
            <v-col xs="12" sm="6" md="4" lg="3">
              <v-autocomplete
                :label="
                  $t('components.guides.health_reasonable_customary.operator')
                "
                v-model="selected.operator"
                clear-icon="clear"
                :items="['And', 'Or']"
                class="required"
                :rules="[$rules.required]"
              ></v-autocomplete>
            </v-col>
          </v-row>
        </v-container>
      </v-form>
    </v-card-text>
    <pbas-data-table
      ref="table"
      :dataProvider="provider"
      :showSelect="false"
      @error="error = $event"
      :noSearch="true"
      :noFilters="true"
    ></pbas-data-table>
    <error-handler :error="error"></error-handler>
  </material-card>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import { ODataProvider } from "pbas-vue-components";
import getFeesHeaders from "@/headers/Fees";
import ErrorHandler from "@/components/ErrorHandler";
import TransSelect2 from "@/components/TransSelect2";
import TransEnum from "@/components/TransEnum";
import NoAutocompleteTextfield from "../NoAutocompleteTextfield.vue";
import TransSelect from "@/components/TransSelect";
export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    TransEnum,
    TransSelect2,
    TransSelect
  },
  data() {
    return {
      error: null,
      provider: undefined,
      selected: {
        benefit: null,
        category: null,
        yearTo: null,
        yearFrom: null,
        coverage: null,
        operator: "And",
      },
      benefits: [],
    };
  },
  computed: {
    ...mapGetters("common", ["settings"]),
    ...mapGetters("plansMembers", ["options"]),
    dateRangeText: {
      get: function() {
        return this.selected.dates.join(" ~ ");
      },
      set: function(newValue) {
        this.selected.dates = [];
      },
    },
  },
  watch: {
    selected: {
      handler(v) {
        if (v) {
          this.loadData();
        }
      },
      deep: true,
    },
  },
  async mounted() {
    this.benefits = (await this.getBenefits()).data.value;
  },
  methods: {
    ...mapActions("claims", ["getBenefits"]),
    years() {
      let years = [];
      for (let year = new Date().getFullYear(); year >= 1900; year--) {
        years.push(year);
      }
      return years;
    },
    loadData() {
      const filter = this.createFilter();
      if (filter) {
        if (this.provider === undefined) {
          this.provider = new ODataProvider(
            this.$axiosHttp,
            this.settings.APIURL + "fees",
            getFeesHeaders(this.options.Models.Province)
          );
          this.provider.filter = filter;
        } else {
          this.provider.filter = filter;
          this.$refs.table.getDataAsync();
        }
      } else {
        this.provider = undefined;
      }
    },
    createFilter() {
      let filters = [];
      if (
        this.selected.operator === null ||
        this.selected.operator === undefined
      ) {
        return null;
      }
      if (
        this.selected.province !== null &&
        this.selected.province !== undefined
      ) {
        filters.push(`FeeGuide/ProvinceId eq ${this.selected.province.Id}`);
      }
      if (
        this.selected.benefit !== null &&
        this.selected.benefit !== undefined
      ) {
        filters.push(`Benefit/Id eq ${this.selected.benefit.Id}`);
      }
      if (
        this.selected.category !== null &&
        this.selected.category !== undefined
      ) {
        filters.push(
          `contains(tolower(Benefit/Category), '${this.selected.category.toLowerCase()}')`
        );
      }
      if (
        this.selected.yearFrom !== null &&
        this.selected.yearFrom !== undefined
      ) {
        filters.push(`FeeGuide/Year ge ${this.selected.yearFrom}`);
      }
      if (this.selected.yearTo !== null && this.selected.yearTo !== undefined) {
        filters.push(`FeeGuide/Year le ${this.selected.yearTo}`);
      }
      if (this.selected.coverage !== null && this.selected.coverage !== undefined) {
        filters.push(`Benefit/Coverage eq '${this.selected.coverage}'`);
      }
      if (filters.length > 0) {
        return filters.join(` ${this.selected.operator.toLowerCase()} `);
      }
      return null;
    },
  },
};
</script>
